import { Alert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';
import { HubCardType } from '@/types';
import { useAccountDetailPress } from '@/experiences/sales-portal/domain/insights/blocs/hooks/use-account-detail-press';
import { useCallback } from 'react';
import { useInsightNavigation } from '@/experiences/sales-portal/domain/insights/blocs/hooks/use-insight-navigation';

export interface UseAlertPressResult {
  onAccountDetailPress: (alert: Alert) => () => void;
  onAlertPress: (alert: Alert) => (() => void) | undefined;
}

export const useAlertPress = (supplierUUID: string): UseAlertPressResult => {
  const openAccountDetail = useAccountDetailPress(supplierUUID);
  const { openAlert } = useInsightNavigation();

  const onAccountDetailPress = useCallback(
    (alert: Alert) => () => openAccountDetail(alert.restaurantUUID),
    [openAccountDetail],
  );

  const onAlertPress = useCallback(
    (alert: Alert) => {
      switch (alert.cardType) {
        case HubCardType.ChurnRisk:
          return onAccountDetailPress(alert);
        case HubCardType.LostItem:
          return () => openAlert(alert);
        case HubCardType.OverduePayment:
          return undefined;
      }
    },
    [onAccountDetailPress, openAlert],
  );

  return { onAccountDetailPress, onAlertPress };
};
